import "../McqCard/mcqCard.css";
import "./Question.css";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

import QuestionChecker from "./QuestionChecker";

import EditCard from "../../EditCard/EditCard";

import { Option, QuestionImg } from "./Component";

import { htmlDecode } from "../../../utils/parse";
import CognitiveIcon from "./Component/CognitivieIcon";

export default function AssertiveAndReasoning({
  isPraticeSession,
  isChecked,
  question,
  index,
  deleteQuestion,
  setQuestId,
  setSelQuest,
  isMarks,
  page,
}) {
  const isSmallScreen = useMediaQuery({
    query: "(max-width:450px)",
  });
  const [edit, setEdit] = useState(false);
  const openEdit = () => setEdit(true);
  const closeEdit = () => setEdit(false);

  const [selectedOption, setSelectedOption] = useState({});

  function isSelected(option) {
    return selectedOption.optionId === option.optionId;
  }

  const isCorrectOption = (optionId) => {
    if (!question.correctAnswers) return false;
    return question.correctAnswers["mcq"] === optionId;
  };

  useEffect(() => {
    if (window.MathJax) {
      window.MathJax.typesetPromise();
    }
  }, [question.question]);

  return (
    <>
      {edit && (
        <EditCard
          edit={edit}
          closeEdit={closeEdit}
          quesType="mcq"
          question={question}
          setQuestId={setQuestId}
          setSelQuest={setSelQuest}
          isMarks={isMarks}
          assessmentType={"competency"}
        />
      )}
      <div
        className={
          isChecked
            ? "my-4 question-c onlineQuestionCard"
            : "my-4 question-c questionCard"
        }
        style={{ display: edit ? "none" : "block" }}
      >
        <div className="superhead">
          <div
            className={
              isPraticeSession ? "remark ps_remark" : "remark ot_remark"
            }
          >
            Assertion and Reasoning
          </div>
          <div
            className={
              isPraticeSession
                ? "mcq__head ps_mcq_head"
                : "mcq__head ot_mcq_head"
            }
          >
            <QuestionChecker
              isStaff={question.onModel === "staff"}
              type={question.questionType}
              correctAnswers={question.correctAnswers[question.questionType]}
              reset={() => setSelectedOption({})}
              options={question.options}
              answers={selectedOption.optionId}
              editMode={edit}
              openEdit={openEdit}
              delete={() => deleteQuestion(question._id)}
              isPraticeSession={isPraticeSession}
              staff={{
                name: question.creatorId?.name,
                schoolName: question.schoolId?.name,
              }}
            >
              <div className="mcqCard">
                <div
                  className="mcqCard__left"
                  style={
                    isPraticeSession
                      ? {
                          marginTop: "16px",
                          fontSize: isSmallScreen ? "16px" : "",
                        }
                      : { marginTop: "" }
                  }
                >
                  <div style={{ minWidth: "fit-content" }}>
                    Q{5 * (page - 1) + index}.&nbsp;
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: htmlDecode(question.question),
                    }}
                  ></div>
                </div>
                {question.cognitive ? (
                  <div className="mcqCard__right">
                    <span
                      className={
                        isPraticeSession
                          ? "difficulty_status bg_ps"
                          : "difficulty_status bg_ot"
                      }
                    >
                      <CognitiveIcon />
                      {question.cognitive}
                    </span>
                  </div>
                ) : null}
              </div>
              <div className="question-description">
                {question.images?.assertImg ? (
                  <QuestionImg image={question.images?.assertImg} />
                ) : null}
                <div
                  className="question-text"
                  style={
                    isPraticeSession
                      ? {
                          fontSize: isSmallScreen ? "1rem" : "1.30rem",
                        }
                      : { marginTop: "" }
                  }
                >
                  <div
                    style={{ display: "flex", gap: "5px" }}
                    dangerouslySetInnerHTML={{
                      __html: `<span>${
                        question.language === "hindi"
                          ? "कथन (A)"
                          : "Assertion (A)"
                      }: </span> <div>${htmlDecode(
                        question?.description?.assertion || "",
                      )}</div>`,
                    }}
                  ></div>
                </div>
              </div>
              <div className="question-description">
                {question.images?.reasonImg ? (
                  <QuestionImg image={question.images?.reasonImg} />
                ) : null}
                <div
                  className="question-text"
                  style={
                    isPraticeSession
                      ? {
                          fontSize: isSmallScreen ? "1rem" : "1.30rem",
                        }
                      : { marginTop: "" }
                  }
                >
                  <div
                    style={{ display: "flex", gap: "5px" }}
                    dangerouslySetInnerHTML={{
                      __html: `<span>${
                        question.language === "hindi"
                          ? "कारण (R)"
                          : "Reasoning (R)"
                      }:</span> <div>${htmlDecode(
                        question?.description?.reasoning || "",
                      )}</div>`,
                    }}
                  ></div>
                </div>
              </div>

              <div className="main_div" style={{ marginTop: "20px" }}>
                <div
                  className="mcq"
                  style={{ width: isSmallScreen ? "100%" : "80%" }}
                >
                  <Option
                    isPraticeSession={isPraticeSession}
                    optionId={question.options[0].optionId}
                    value={htmlDecode(question.options[0]?.value || "")}
                    image={question.images?.op1}
                    isSelected={isSelected(question.options[0])}
                    selectOption={() => setSelectedOption(question.options[0])}
                  />

                  <Option
                    isPraticeSession={isPraticeSession}
                    optionId={question.options[1].optionId}
                    value={htmlDecode(question.options[1].value)}
                    image={question.images?.op2}
                    isSelected={isSelected(question.options[1])}
                    selectOption={() => setSelectedOption(question.options[1])}
                  />

                  <Option
                    isPraticeSession={isPraticeSession}
                    optionId={question.options[2].optionId}
                    value={htmlDecode(question.options[2].value)}
                    image={question.images?.op3}
                    isSelected={isSelected(question.options[2])}
                    selectOption={() => setSelectedOption(question.options[2])}
                  />

                  <Option
                    isPraticeSession={isPraticeSession}
                    optionId={question.options[3].optionId}
                    value={htmlDecode(question.options[3].value)}
                    image={question.images?.op4}
                    isSelected={isSelected(question.options[3])}
                    selectOption={() => setSelectedOption(question.options[3])}
                  />
                </div>
              </div>
            </QuestionChecker>
          </div>
        </div>
      </div>
    </>
  );
}
